import { getGameId } from "@/utils";
// 游戏配置接口
export interface GameConfig {
  title: string;
  favicon: string;
  homeBanner: string;
  iconEmpty: string;
  profileBanner: string;
}

// 游戏配置映射
export const gameConfigs: Record<string, GameConfig> = {
  "191": {
    title: "Puzzles & Survival",
    favicon: new URL("@/assets/favicon/191.jpg", import.meta.url).href,
    homeBanner: new URL("@/assets/home-banner-191.jpg", import.meta.url).href,
    iconEmpty: new URL("@/assets/icon-empty-191.png", import.meta.url).href,
    profileBanner: new URL("@/assets/profile-banner-191.jpg", import.meta.url)
      .href,
  },
  "430": {
    title: "와다다 던전런",
    favicon: new URL("@/assets/favicon/430.png", import.meta.url).href,
    homeBanner: new URL("@/assets/home-banner-430.jpg", import.meta.url).href,
    iconEmpty: new URL("@/assets/icon-empty-430.png", import.meta.url).href,
    profileBanner: new URL("@/assets/profile-banner-430.jpg", import.meta.url)
      .href,
  },
  "386": {
    title: "RO仙境傳説：世界之旅",
    favicon: new URL("@/assets/favicon/386.jpg", import.meta.url).href,
    homeBanner: new URL("@/assets/home-banner-386.jpg", import.meta.url).href,
    iconEmpty: new URL("@/assets/icon-empty-386.png", import.meta.url).href,
    profileBanner: new URL("@/assets/profile-banner-386.jpg", import.meta.url)
      .href,
  },
  "440": {
    title: "Last Asylum: Plague",
  },
  // 可以继续添加更多游戏配置
};

// 获取游戏配置的工具函数
export const getGameConfig = (): GameConfig => {
  const gameId = getGameId();
  return gameConfigs[gameId] || {};
};

// 支持的游戏ID列表
export const supportedGameIds = Object.keys(gameConfigs);
